export enum ECompany {
  APNETWORKS = 'apnetworks',
  KM_DO_BRASIL = 'km-do-brasil'
}
